"use client"

import * as AccordionPrimitive from "@radix-ui/react-accordion"
import { AccordionItem } from "@/components/molecules/AccordionItem/accordion-item"

const Accordion = AccordionPrimitive.Root

export { Accordion, AccordionItem }
